export default [
  'zoom',
  'ms_teams'
]
